

$(document).ready(function() {
  $("#sidebar-nav ul li ul").hide();
  $("#sidebar-nav ul li").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings("#sidebar-nav ul li ul").slideUp(500);
    } else {
      $("#sidebar-nav ul li").removeClass("active");
      $(this).addClass("active");
      $("#sidebar-nav ul li ul").slideUp(500);
      $(this).siblings("#sidebar-nav ul li ul").slideDown(500);
    }
  });
});


$(document).ready(function() {
  $("#sidebar-nav ul li ul li ul").hide();
  $("#sidebar-nav ul li ul li").on("click", function() {
    if ($(this).hasClass("active1")) {
      $(this).removeClass("active1");
      $(this).siblings("#sidebar-nav ul li ul li ul").slideUp(500);
    } else {
      $("#sidebar-nav ul li ul li ul").removeClass("active1");
      $(this).addClass("active1");
      $("#sidebar-nav ul li ul li ul").slideUp(500);
      $(this).siblings("#sidebar-nav ul li ul li ul").slideDown(500);
    }
  });
});


$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
});